import loadable from '@loadable/component';
import PageLoader from '@yaydoo/react-components/lib/components/AppLoaders/PageLoader';

const UserProfile = loadable(
  () =>
    import(
      /* webpackChunkName: "Statements" */
      './Profile'
    ),
  {
    fallback: <PageLoader type="icon" />,
  },
);

export default UserProfile;
